
import React, { Component } from 'react';


import ResizableRect from 'react-resizable-rotatable-draggable';
import yourImage from '../overlays/20.png';



class Accessories extends Component {
  
  constructor() {
    super();
    this.state = {
      width: 200,
      height: 200,
      top: 660,
      left: 50,
      rotateAngle: 0,
    };
    
  }

  handleResize = (style, isShiftKey, tc) => {
    let { top, left, width, height } = style;
    top = Math.round(top);
    left = Math.round(left);
    width = Math.round(width);
    height = Math.round(height);
    this.setState({
      top,
      left,
      width,
      height,
    })
  };

  handleRotate = (rotateAngle) => {
    this.setState({
      rotateAngle,
    })
  };

  handleDrag = (deltaX, deltaY) => {
    this.setState({
      left: this.state.left + deltaX,
      top: this.state.top + deltaY,
      
    });
  };

  render() {
    const { width, top, left, height, rotateAngle } = this.state;
    
    return (
      <div className="App" >
        {/* Draggable Image */}
        <div
          style={{
          //  border: '10 px', 
            position: 'absolute',
            top,
            left,
            transform: `rotate(${rotateAngle}deg)`,
          }}
        >
           <img src={yourImage} style={{ width, height}} alt="Draggable Image" /> 
        </div>

        {/* Fixed Image */}
        {/* <div
          style={{
            position: 'fixed',
            top: 160, // Adjust the position according to your needs
            left: 50, // Adjust the position according to your needs
            zIndex: 0, // Set a lower zIndex to keep it behind the draggable image
            border: '2px solid white', // Border styling remains fixed
            backgroundColor: 'orange',
          }}
        >
          <img src={yourImage} style={{ width, height }} alt="Fixed Image" />
        </div> */}

        {/* Resizable and Rotatable Rect */}
        {this.props.isVisible && <ResizableRect
          
        
          left={left}
          top={top}
          width={width}
          height={height}
          rotateAngle={rotateAngle}
          onRotate={this.handleRotate}
          onResize={this.handleResize}
          onDrag={this.handleDrag}   
          zoomable = 'ne,n, e'
          
        /> }
      </div>
    );
  }
}

export default Accessories;

